export const createParams = ({ keyValues, page, searchParams }: any) => {
  page !== undefined && searchParams.set('page', page);
  Object.keys(keyValues).map((key) =>
    keyValues[key] ? searchParams.set(key, keyValues[key]) : searchParams.delete(key)
  );
  return Object.fromEntries([...searchParams]);
};
